<template>
  <div>

    <el-dialog title="编辑包装尺寸" :visible.sync="visible" width="600px">
      <div class="change-size-dialog">
        <div class="change-size-dialog-item">
          <span class="title">包装尺寸(cm)：</span>
          <el-select class="select" v-model="boxCode" @change="changeTemplate">
            <el-option :label="item.templateName" :value="item.boxTemplateId
              " v-for="item in boxList" :key="item.value"></el-option>
          </el-select>
          <el-input class="input" placeholder="长" @input="changeInput('length')" v-model="boxInfo.length"
            maxlength="6"></el-input>
          <span>*</span>
          <el-input class="input" placeholder="宽" @input="changeInput('width')" v-model="boxInfo.width"
            maxlength="6"></el-input>
          <span>*</span>
          <el-input class="input" placeholder="高" @input="changeInput('height')" v-model="boxInfo.height"
            maxlength="6"></el-input>
        </div>
        <div class="change-size-dialog-item">
          <span class="title"><span style="color:red">*</span>三边和(cm)：</span>
          <el-select class="select" v-model="boxInfo.threeSideSum">
            <el-option :label="item.name" :value="item.code
              " v-for="item in threeSideList" :key="item.code" @change="changeTemplate"></el-option>
          </el-select>
          <span class="title" style="padding-left: 20px;"><span style="color:red">*</span>厚度(cm)：</span>
          <el-input class="input-num" v-model="boxInfo.thickness" @input="changeInput('thickness')" maxlength="7"></el-input>
        </div>
        <div class="change-size-dialog-item">
          <span class="title">适用范围：</span>
          <el-radio v-model="boxInfo.scopeOfApplication" :label="1">仅当前sku</el-radio>
          <el-radio v-model="boxInfo.scopeOfApplication" :label="2">全部spu</el-radio>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { threeSideSumEnumsApi, getByShopProductSkuApi, editShopProductSizeApi } from '@/apis/inventoryDetails'
import {
  getBox
} from "@/apis/outStock";
export default {
  name: 'changeSize',
  data() {
    return {
      boxList: [],
      visible: false,
      boxCode: '',
      boxInfo: {
        width: '',
        height: '',
        length: '',
        threeSideSum: '',
        thickness: '',
        scopeOfApplication: 1
      },
      threeSideList: [],
      shopProductSku: ''
    }
  },
  methods: {
    open(record) {
      this.visible = true
      this.shopProductSku = record.shopProductSku
      getByShopProductSkuApi({
        shopProductSku: record.shopProductSku
      }).then((res) => {
        this.boxInfo.width = String(res.data?.width ?? '')
        this.boxInfo.height = String(res.data?.height ?? '')
        this.boxInfo.length = String(res.data?.length ?? '')
        this.boxInfo.threeSideSum = String(res.data?.threeSideSum ?? '')
        this.boxInfo.thickness = String(res.data?.thickness ?? '')
        this.boxInfo.scopeOfApplication = res.data?.scopeOfApplication ?? 1
      })
    },
    changeTemplate(templateId) {
      console.log(templateId)
      const sizeItem = this.boxList.find(v => v.boxTemplateId === templateId)
      this.boxInfo.width = sizeItem.width
      this.boxInfo.height = sizeItem.height
      this.boxInfo.length = sizeItem.length
      this.changeThree()
    },
    changeInput(key) {
      this.boxInfo[key] = this.boxInfo[key]?.match(/\d+\.?\d{0,1}/)?.[0] ?? ''
      if(key === 'height') {
        this.boxInfo.thickness = this.boxInfo.height
      }
      this.changeThree()
    },
    changeThree() {
      if (this.boxInfo.length && this.boxInfo.width && this.boxInfo.height) {
        const threeSideSum = Number(this.boxInfo.length) + Number(this.boxInfo.width) + Number(this.boxInfo.height)
        let code = ''
        this.threeSideList.forEach((item) => {
          if (code) return
          if (threeSideSum <= item.code) {
            code = item.code
          }
        })
        this.boxInfo.threeSideSum = code
      }
    },
    submit() {
      if (!this.boxInfo.threeSideSum || !this.boxInfo.thickness || !this.boxInfo.length || !this.boxInfo.width || !this.boxInfo.height) {
        this.$message.warning('请填写完整信息')
        return
      }
      if(Number(this.boxInfo.length) <= 0) {
        this.$message.warning('长必须大于0')
        return
      }
      if(Number(this.boxInfo.width) <= 0) {
        this.$message.warning('宽必须大于0')
        return
      }
      if(Number(this.boxInfo.height) <= 0) {
        this.$message.warning('高必须大于0')
        return
      }
      if(Number(this.boxInfo.thickness) <= 0) {
        this.$message.warning('厚度必须大于0')
        return
      }
      editShopProductSizeApi({
        ...this.boxInfo,
        shopProductSku: this.shopProductSku
      }).then(({success}) => {
        if(success) {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('success')
        }
      })
    }
  },
  mounted() {
    getBox().then(({ code, data }) => {
      if (code == 0) {
        this.boxList = data;
      }
    });
    threeSideSumEnumsApi().then(({ code, data }) => {
      if (code == 0) {
        this.threeSideList = data;
      }
    });
  }
}
</script>
<style lang="less">
.change-size-dialog {
  .change-size-dialog-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .title {
      width: 140px;
      text-align: left;
    }

    .input {
      width: 60px;
      margin: 0 10px;
    }

    .input-num {
      width: 150px;
    }
  }
}
</style>
